var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "flex w-full overflow-x-hidden",
      attrs: { id: "form-activity", autocomplete: "off" }
    },
    [
      _c(
        "div",
        { staticClass: "w-full p-2" },
        [
          _c("div", { staticClass: "flex flex-col items-center mb-6" }, [
            _c(
              "label",
              {
                staticClass:
                  "block uppercase text-gray-600 text-xs font-bold mb-2 text-left"
              },
              [_vm._v("Avatar")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "px-4 mb-6" }, [
              _c("img", {
                staticClass:
                  "shadow rounded max-w-full h-auto align-middle border-none",
                staticStyle: { width: "150px" },
                attrs: {
                  alt: "...",
                  src: _vm.input.avatar ? _vm.input.avatar : _vm.imgPlaceholder
                }
              })
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.isFileLarge ||
            (_vm.$v.input.avatar.$dirty && !_vm.$v.input.avatar.required)
              ? _c(
                  "div",
                  { staticClass: "flex flex-col mb-2" },
                  [
                    _vm.isFileLarge
                      ? _c("text-error", {
                          attrs: { text: "Please select correct file" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.input.avatar.$dirty && !_vm.$v.input.avatar.required
                      ? _c("text-error", {
                          attrs: { text: "Please select channel artwork." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              [
                !_vm.input.avatar
                  ? _c("Button", {
                      attrs: { label: "Browse File" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "any",
                            fn: function() {
                              return [
                                _c("input", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%",
                                    position: "absolute",
                                    left: "0",
                                    top: "0",
                                    opacity: "0",
                                    cursor: "pointer",
                                    "z-index": "2"
                                  },
                                  attrs: {
                                    type: "file",
                                    name: "profile_picture"
                                  },
                                  on: { change: _vm.onFileChange }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2462335240
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.input.avatar
                  ? _c("Button", {
                      attrs: { label: "Remove", variant: "default" },
                      on: { clicked: _vm.changeImage }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col items-center mb-6" }, [
            _c(
              "label",
              {
                staticClass:
                  "block uppercase text-gray-600 text-xs font-bold mb-2 text-left"
              },
              [_vm._v("Background Image")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "px-4 mb-6" }, [
              _c("img", {
                staticClass:
                  "shadow rounded max-w-full h-auto align-middle border-none",
                staticStyle: { width: "150px" },
                attrs: {
                  alt: "...",
                  src: _vm.input.background_image
                    ? _vm.input.background_image
                    : _vm.imgPlaceholder
                }
              })
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm.isFileLargeBg ||
            (_vm.$v.input.background_image.$dirty &&
              !_vm.$v.input.background_image.required)
              ? _c(
                  "div",
                  { staticClass: "flex flex-col mb-2" },
                  [
                    _vm.isFileLargeBg
                      ? _c("text-error", {
                          attrs: { text: "Please select correct file" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.input.background_image.$dirty &&
                    !_vm.$v.input.background_image.required
                      ? _c("text-error", {
                          attrs: { text: "Please select background image." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              [
                !_vm.input.background_image
                  ? _c("Button", {
                      attrs: { label: "Browse File" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "any",
                            fn: function() {
                              return [
                                _c("input", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%",
                                    position: "absolute",
                                    left: "0",
                                    top: "0",
                                    opacity: "0",
                                    cursor: "pointer",
                                    "z-index": "2"
                                  },
                                  attrs: {
                                    type: "file",
                                    name: "background_image"
                                  },
                                  on: { change: _vm.onFileChangeBg }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2272293859
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.input.background_image
                  ? _c("Button", {
                      attrs: { label: "Remove", variant: "default" },
                      on: { clicked: _vm.changeImageBg }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Channel Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Input", {
                      attrs: {
                        placeholder: "ex. Channel Name",
                        error:
                          _vm.$v.input.name.$dirty &&
                          (!_vm.$v.input.name.required ||
                            !_vm.$v.input.name.maxLength),
                        maxlength: "100"
                      },
                      model: {
                        value: _vm.input.name,
                        callback: function($$v) {
                          _vm.$set(_vm.input, "name", $$v)
                        },
                        expression: "input.name"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.name.$dirty && !_vm.$v.input.name.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill Channel Name." }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.input.name.$dirty && !_vm.$v.input.name.maxLength
                          ? _c("text-error", {
                              attrs: {
                                text:
                                  "Max length Channel name is 100 character."
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Channel Email" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Input", {
                      attrs: {
                        placeholder: "ex. Channel Email",
                        error:
                          _vm.$v.input.email.$dirty &&
                          (!_vm.$v.input.email.required ||
                            !_vm.$v.input.email.email)
                      },
                      model: {
                        value: _vm.input.email,
                        callback: function($$v) {
                          _vm.$set(_vm.input, "email", $$v)
                        },
                        expression: "input.email"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.email.$dirty &&
                        !_vm.$v.input.email.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill Channel Email." }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.input.email.$dirty && !_vm.$v.input.email.email
                          ? _c("text-error", {
                              attrs: { text: "Email is not valid format." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Country of Residence" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Select", {
                      attrs: {
                        "empty-label": "All Countries",
                        error:
                          _vm.$v.input.country_code.$dirty &&
                          !_vm.$v.input.country_code.required,
                        data: _vm.dataListCountry
                      },
                      model: {
                        value: _vm.input.country_code,
                        callback: function($$v) {
                          _vm.$set(_vm.input, "country_code", $$v)
                        },
                        expression: "input.country_code"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.country_code.$dirty &&
                        !_vm.$v.input.country_code.required
                          ? _c("text-error", {
                              attrs: { text: "Please select the country." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Channel Description" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "relative" },
                      [
                        _c("TextArea", {
                          attrs: {
                            placeholder: "Description Channel",
                            error:
                              _vm.$v.input.description.$dirty &&
                              (!_vm.$v.input.description.required ||
                                !_vm.$v.input.description.maxLength),
                            rows: "5"
                          },
                          model: {
                            value: _vm.input.description,
                            callback: function($$v) {
                              _vm.$set(_vm.input, "description", $$v)
                            },
                            expression: "input.description"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "absolute right-0 text-xs",
                            staticStyle: { bottom: "15px", right: "15px" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.input.description.length) +
                                "/" +
                                _vm._s(_vm.maxLengthDesc)
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.description.$dirty &&
                        !_vm.$v.input.description.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill the Description." }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.input.description.$dirty &&
                        !_vm.$v.input.description.maxLength
                          ? _c("text-error", {
                              attrs: {
                                text:
                                  "Max length description channel is 750 character"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col mb-2" }, [
      _c("p", { staticClass: "text-xs text-gray-700" }, [
        _vm._v("Minimum 900x900, Maximum 1MB")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col mb-2" }, [
      _c("p", { staticClass: "text-xs text-gray-700" }, [_vm._v("Maximum 1MB")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fd5f836", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fd5f836","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionsVideos/Channel/ChannelForm.vue
// module id = null
// module chunks = 